import styled from 'styled-components';
import wixService from '../../../../../../services/wixService';

function getMobileQuestionTitleFontSize(settings) {
  return settings.isNewApp && wixService.isMobile()
    ? settings.mobile.questionsFontSize + 'px !important'
    : '';
}

function getMobileAnswerFontSize(settings) {
  return settings.isNewApp && wixService.isMobile()
    ? settings.mobile.answersFontSize + 'px !important'
    : '';
}

export const QuestionBasicBlock = styled.div.attrs(() => ({}))`
  div,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0 !important;
    padding: 0 !important;
    direction: ${(props) => props.settings.direction};
    color: ${(props) =>
      wixService.getColorByreference(props.design.questionText.color.value)};
    color: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.design.questionText.color.name,
      )};
    ${(props) =>
      wixService.getStyleFontByReference(props.design.questionText.font.value)};
    font-size: ${(props) => props.design.questionText.font.startWithSize}px;
    font: ${(props) =>
      wixService.getFontValueByComponentName(
        props.styleParams,
        props.design.questionText.font.name,
      )};
    font-size: ${(props) => getMobileQuestionTitleFontSize(props.settings)};
    text-decoration: ${(props) =>
      wixService.getFontTextDecoration(
        props.styleParams,
        props.design.questionText.font.name,
      )} !important;
  }
`;

export const AnswerBasicBlock = styled.div.attrs(() => ({}))`
  margin-top: 20px !important;
  div[data-id='content-viewer'],
  blockquote,
  p,
  ul,
  li,
  > span {
    direction: ${(props) => props.settings.direction};
    color: ${(props) =>
      wixService.getColorByreference(
        props.design.answerText.color.value,
      )}!important;
    color: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.design.answerText.color.name,
      )}!important;
    ${(props) =>
      wixService.getStyleFontByReference(props.design.answerText.font.value)};
    font: ${(props) =>
      wixService.getFontValueByComponentName(
        props.styleParams,
        props.design.answerText.font.name,
      )};
    font-size: ${(props) => getMobileAnswerFontSize(props.settings)};
    text-decoration: ${(props) =>
      wixService.getFontTextDecoration(
        props.styleParams,
        props.design.answerText.font.name,
      )} !important;
  }

  a span {
    color: ${(props) =>
      wixService.getColorByreference(
        props.design.answersLinks.color.value,
      )}!important;
    color: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.design.answersLinks.color.name,
      )}!important;
  }
`;

export const SocialBarIcons = styled.div.attrs(() => ({}))`
  margin-bottom: 40px;
  .iconList {
    margin-bottom: 20px;
    color: ${(props) =>
      wixService.getColorByreference(
        props.design.questionText.color.value,
      )} !important;
    color: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.design.questionText.color.name,
      )} !important;
    svg path {
      fill: ${(props) =>
        wixService.getColorByreference(
          props.design.questionText.color.value,
        )} !important;
      fill: ${(props) =>
        wixService.getColorValueByComponentName(
          props.styleParams,
          props.design.questionText.color.name,
        )} !important;
      fill-rule: evenodd;
    }
  }
`;
